module.exports = __webpack_public_path__ + "img/jyb-ios.b7e67f97.png";